import React from "react";
export function EmbeddedHtmlBlock(props) {
    return (React.createElement("div", { "data-testid": "EmbeddedHtmlBlock", dangerouslySetInnerHTML: { __html: props.data.htmlContent.value || "" } }));
}
